import { IRatingItem } from 'api/resort/types';
import classNames from 'classnames';
import { ReactComponent as SvgLike } from 'public/assets/icons/like.svg';
import { ReactComponent as SvgDislike } from 'public/assets/icons/dislike.svg';
import styles from './styles.module.scss';

export const Review = ({
  review, className,
}: {
  review: IRatingItem,
  className?: string,
}) => (
  <div className={classNames(styles.wrapper, className)}>

    <div className={styles.headerName}>
      <span className={classNames('h3', styles.h3, styles.name)}>{`${review.firstName ?? ''} ${review.lastName ?? ''}`}</span>
    </div>
    {review.review}
    <footer>
      <div className={styles.level}>
        {review.pros && (
        <div className={styles.pros} title={review.pros}>
          <SvgLike />
          <span className={styles.text}>
            {review.pros}
          </span>
        </div>
        )}
        {review.cons && (
        <div className={styles.cons}>
          <SvgDislike />
          <span className={styles.text} title={review.cons}>
            {review.cons}
          </span>
        </div>
        )}
      </div>
    </footer>
  </div>
);
